<template>
    <section class="inline large bg-default">
        <div class="grid xs-grid-cols-1 fixed fixed-max-sm gap-3">
            <div v-if="showState" class="grid gap-1 fixed middle xs-grid-cols-2 sm-grid-cols-2 md-grid-cols-3">
                <div class="wrap">
                    <h2 class="text-bold f3 text-capitalize">Top agents by state</h2>
                </div>
                <template v-for="(item, i) in states">
                    <div class="singleline" v-if="i < max || moreState">
                        <a class="link" :href="item.url">{{item.text}}</a>
                    </div>
                </template>
                <div class="wrap" v-if="moureStateData">
                    <a href="javascript:;" @click="toggleState" class="link">{{!moreState ?  'Show More' : 'Show Less' }}</a>
                </div>
            </div>
            <div v-if="showCounty" class="grid gap-1 fixed middle xs-grid-cols-2 sm-grid-cols-2 md-grid-cols-3">
                <div class="wrap">
                    <h2 class="text-bold f3 text-capitalize">{{!hasCountyData ? 'real estate agents by popular' : 'real estate agents by nearby'}} counties</h2>
                </div>
                <template v-for="(item, i) in getCounties">
                    <div class="singleline" v-if="i < max || moreCounty">
                        <a class="link" :href="item.url">{{item.text}}</a>
                    </div>
                </template>
                <div class="wrap" v-if="moreCountyData">
                    <a href="javascript:;" @click="toggleCounty" class="link">{{!moreCounty ?  'Show More' : 'Show Less' }}</a>
                </div>
            </div>
            <div class="grid gap-1 fixed middle xs-grid-cols-2 sm-grid-cols-2 md-grid-cols-3">
                <div class="wrap">
                    <h2 class="text-bold f3 text-capitalize">{{!hasCityData  ? 'real estate agents by popular' : 'real estate agents by nearby'}} cities</h2>
                </div>
                <template v-for="(item, i)  in getCities">
                    <div class="singleline" v-if="i < max || moreCity">
                        <a class="link" :href="item.url">{{item.text}}</a>
                    </div>
                </template>
                <div class="wrap" v-if="moreCityData">
                    <a href="javascript:;" @click="toggleCity" class="link">{{!moreCity ?  'Show More' : 'Show Less' }}</a>
                </div>
            </div>
        </div>
    </section>
</template>
<script src="./agent-region.js"></script>